import React, { useState } from 'react';
import { apiFetch } from '../constants';
import AuthPageHeader from './AuthPageHeader';
import { tUi } from '../utils/uiText';

export default function SignupRequestPage({ onBackToLogin }) {
  const uiLanguage = 'en';
  const [form, setForm] = useState({
    company_name: '',
    contact_name: '',
    contact_email: '',
    use_case: '',
    website: '',
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await apiFetch('/api/signup/request', {
        method: 'POST',
        body: JSON.stringify(form),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.detail || tUi(uiLanguage, 'signupUnableToSubmit'));
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message || tUi(uiLanguage, 'signupUnableToSubmit'));
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
        <div className="w-full max-w-md border border-teal-500/30 rounded-2xl bg-gray-950 p-8 text-center">
          <h1 className="text-2xl font-semibold mb-3">{tUi(uiLanguage, 'signupRequestReceivedTitle')}</h1>
          <p className="text-gray-400 text-sm mb-6">
            {tUi(uiLanguage, 'signupRequestReceivedBody')}
          </p>
          <button
            type="button"
            onClick={onBackToLogin}
            className="px-4 py-2 bg-teal-500 hover:bg-teal-400 text-black font-semibold rounded-lg"
          >
            {tUi(uiLanguage, 'signupBackToSignIn')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md border border-teal-500/30 rounded-2xl bg-gray-950 p-8 shadow-2xl">
        <AuthPageHeader
          title={tUi(uiLanguage, 'signupRequestAccessTitle')}
          subtitle={tUi(uiLanguage, 'signupRequestAccessBody')}
        />

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="website"
            value={form.website}
            onChange={(e) => setForm({ ...form, website: e.target.value })}
            className="hidden"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
          />

          <div>
            <label className="block text-sm text-gray-300 mb-1">{tUi(uiLanguage, 'signupCompanyName')}</label>
            <input
              value={form.company_name}
              onChange={(e) => setForm({ ...form, company_name: e.target.value })}
              required
              maxLength={120}
              className="w-full px-4 py-2 bg-black border border-teal-500/30 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-1">{tUi(uiLanguage, 'signupYourName')}</label>
            <input
              value={form.contact_name}
              onChange={(e) => setForm({ ...form, contact_name: e.target.value })}
              required
              maxLength={120}
              className="w-full px-4 py-2 bg-black border border-teal-500/30 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-1">{tUi(uiLanguage, 'signupWorkEmail')}</label>
            <input
              type="email"
              value={form.contact_email}
              onChange={(e) => setForm({ ...form, contact_email: e.target.value })}
              required
              className="w-full px-4 py-2 bg-black border border-teal-500/30 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-1">{tUi(uiLanguage, 'signupUseCaseLabel')}</label>
            <textarea
              value={form.use_case}
              onChange={(e) => setForm({ ...form, use_case: e.target.value })}
              rows={4}
              maxLength={2000}
              className="w-full px-4 py-2 bg-black border border-teal-500/30 rounded-lg"
              placeholder={tUi(uiLanguage, 'commonOptional')}
            />
          </div>

          {error && (
            <div className="text-sm text-red-400 bg-red-950/40 border border-red-500/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-2 bg-teal-500 hover:bg-teal-400 disabled:bg-gray-700 text-black font-semibold rounded-lg"
          >
            {loading ? tUi(uiLanguage, 'signupSubmitting') : tUi(uiLanguage, 'signupSubmitRequest')}
          </button>
        </form>

        <button
          type="button"
          onClick={onBackToLogin}
          className="w-full mt-4 text-sm text-gray-400 hover:text-white"
        >
          {tUi(uiLanguage, 'signupBackToSignIn')}
        </button>
      </div>
    </div>
  );
}
